import { initializeLocationColors } from "~/composables/agenda/useLocationLegend";
import { getOAuthUser } from "~/utils/oauthUserStorage";

export default defineNuxtPlugin({
  name: "init-location-colors",
  enforce: "post",
  async setup() {
    if (import.meta.env.STORYBOOK) return;
    try {
      const user = getOAuthUser();

      if (!user) return;

      const { bearerToken } = await useOAuth();
      const token = bearerToken();

      if (!token) return;

      const { isEmployee } = await useCurrentUserProfile();

      if (!isEmployee) {
        return;
      }

      await initializeLocationColors();
    } catch (err) {
      console.warn("Failed to initialize location colors:", err);
      const error = err as { response?: { status?: number }; message?: string };
      if (error?.response?.status === 401 || error?.message?.includes("401")) return;
    }
  },
});
